import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
type Testimonial = {
  name: string;
  role: string;
  photo: string;
  rating: number;
  text: string;
};
const testimonials: Testimonial[] = [{
  name: 'Andrés Villalobos',
  role: 'Fundador de agencia comercial',
  photo: 'https://randomuser.me/api/portraits/men/32.jpg',
  rating: 5,
  text: 'Llevaba dos años siendo el único que podía cerrar una venta. Con el Sistema Nervioso Comercial documenté todo mi proceso y por primera vez me tomé una semana libre sin que la operación se detuviera.'
}, {
  name: 'Mariana Ortega',
  role: 'Consultora comercial B2B',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  rating: 5,
  text: 'Conseguí mi primer cliente de $2,000 al mes con la prospección orgánica en LinkedIn. Cero presupuesto en publicidad. El manual vale mil veces lo que cuesta.'
}, {
  name: 'Diego Fuentes',
  role: 'Dueño de call center',
  photo: 'https://randomuser.me/api/portraits/men/68.jpg',
  rating: 5,
  text: 'Confundía crecer con escalar. Ahora entiendo la diferencia y dejé de contratar vendedores para empezar a reclutar asesores. Mi facturación recurrente subió 40% en cuatro meses.'
}, {
  name: 'Valentina Ríos',
  role: 'Emprendedora',
  photo: 'https://randomuser.me/api/portraits/women/65.jpg',
  rating: 5,
  text: 'Pensaba que necesitaba capital para empezar en serio. Este manual me demostró que lo que me faltaba era un proceso, no dinero. Arranqué mi equipo de ventas literalmente desde cero.'
}, {
  name: 'Carlos Mendoza',
  role: 'Director comercial',
  photo: 'https://randomuser.me/api/portraits/men/52.jpg',
  rating: 5,
  text: 'El Score Leaderar cambió por completo cómo priorizo mis oportunidades. Dejé de perseguir clientes que nunca iban a comprar y mi cierre mejoró notablemente.'
}, {
  name: 'Sofía Herrera',
  role: 'Fundadora de startup de servicios',
  photo: 'https://randomuser.me/api/portraits/women/28.jpg',
  rating: 5,
  text: 'Por menos de lo que cuesta un café tuve la claridad que ningún curso caro me había dado. Lo leí en una tarde y esa misma semana empecé a aplicarlo.'
}];
function Stars({
  rating
}: {
  rating: number;
}) {
  return <div className="mb-4 flex gap-0.5" aria-label={`${rating} de 5 estrellas`} data-id="element-12">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`h-4 w-4 ${i < rating ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} data-id="element-13" />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-slate-50 px-4 py-20 sm:px-6 lg:px-8" data-id="element-14">
      <div className="mx-auto max-w-5xl" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center text-3xl font-bold text-slate-900 sm:text-4xl" data-id="element-16">
          Lo que dicen quienes ya lo aplicaron
        </motion.h2>

        <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 [column-fill:_balance]" data-id="element-17">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.1
        }} className="mb-6 break-inside-avoid rounded-2xl bg-white p-6 shadow-sm ring-1 ring-slate-200" data-id="element-18">
              <Stars rating={t.rating} data-id="element-19" />
              <blockquote className="text-slate-700" data-id="element-20">"{t.text}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-21">
                <img src={t.photo} alt={t.name} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-slate-100" data-id="element-22" />
                <div data-id="element-23">
                  <div className="font-semibold text-slate-900" data-id="element-24">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-25">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}